const teams = [
  {
    id: 1,
    imageUrl: "/assets/img/avatars/avatar2.jpg",
    name: "Mr. Sai Kumar ",
    // designation: "IT Expert",
  },
  {

    
    id: 2,
    imageUrl: "/assets/img/avatars/avatar1.jpg",
    name: "Ms . Madhulatha",
    // designation: "Web Designer",
  },
  {
    id: 3,
    imageUrl: "/assets/img/avatars/avatar3.jpg",
    name: "Mr. Midhin",
    // designation: "Content Writer",
  },
  {
    id: 4,
    imageUrl: "/assets/img/avatars/avatar4.jpg",
    name: " Ms . Swathi",
    // designation: "Marketing officer",
  },
];
export {
    teams
}




